import { motion, AnimatePresence } from "framer-motion";
import { DateTime } from "luxon";
import ephLogo from "../../images/logo-min.png";
import outLookLogo from "../../images/outLook_logo.png";

export default function ContactLogRow({ log, onSelect, selected }) {
  const isOutlook = log.isOutlook;
  const contactDate = isOutlook ? log.emailDate : log.dateContacted;
  const emailData = isOutlook ? JSON.parse(log.emailObject || "{}") : null;

  const handleToggle = () => {
    if (isOutlook) {
      if (selected) {
        onSelect(null); // close if already selected
      } else {
        onSelect(log); // open if new
      }
    }
  };

  const formatGraphTime = (dateTimeStr, timeZoneStr = "UTC") => {
    try {
      const dt = DateTime.fromISO(dateTimeStr, { zone: timeZoneStr }).toLocal();
      return dt.toFormat("yyyy-MM-dd'T'HH:mm");
    } catch {
      return "";
    }
  };

  const dateTimeValue = isOutlook
    ? formatGraphTime(emailData?.receivedDateTime || emailData?.sentDateTime)
    : new Date(contactDate).toISOString().slice(0, 16);

  return (
    <motion.div
      className={`relative border rounded-md px-4 py-3 mb-2 text-sm leading-snug transition-colors duration-300 flex items-center ${
        selected ? "bg-blue-50 border-blue-400" : "bg-white border-gray-200"
      } ${isOutlook ? "cursor-pointer hover:bg-blue-50" : ""}`}
      // onClick={handleToggle}
      initial={false}
      animate={{ backgroundColor: selected ? "#eff6ff" : "#ffffff" }}
      transition={{ duration: 0.3 }}
    >
      {/* Column 1: Log info */}
      <div className="flex-1 pr-4">
        <p className="text-gray-700">
          <span className="font-medium text-gray-800">{log.contactedBy}</span> via{" "}
          <span className="capitalize">{log.contactMethod}</span> for{" "}
          <span className="font-medium">
            {isOutlook && emailData?.subject ? emailData.subject : log.contactedFor}
          </span>
        </p>
        <div className="flex items-center gap-1 mt-1 text-xs text-gray-500">
          {log.isIncoming ? 'Received at' : log.isOutgoing ? 'Sent at' : null}
          <input
            type="datetime-local"
            className="bg-transparent pointer-events-none select-none text-xs text-gray-500"
            value={dateTimeValue}
            readOnly
          />
        </div>
      </div>

      {/* Column 2: Logo */}
      <div className="flex items-center justify-center w-10 h-10">
        {isOutlook ? (
          <img
            src={outLookLogo}
            alt="Outlook"
            className="w-8 h-8 object-contain"
            title="Outlook Email"
          />
        ) : (
          <img
            src={ephLogo}
            alt="EPH Tool"
            className="w-16 h-16 object-contain"
            title="EPH Tool"
          />
        )}
      </div>

      {/* Column 3: Arrow */}
      {/* {isOutlook && (
        <div className="w-6 text-right">
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleToggle();
            }}
            className="text-gray-500 hover:text-blue-600 transition-colors duration-200"
          >
            <AnimatePresence mode="wait">
              <motion.i
                key={selected ? "right" : "left"}
                className="fa-solid text-lg"
                initial={{ opacity: 0, x: selected ? -10 : 10 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: selected ? 10 : -10 }}
                transition={{ type: "spring", stiffness: 300, damping: 20 }}
              >
                <i className={`fa-solid fa-angle-${selected ? "right" : "left"}`} />
              </motion.i>
            </AnimatePresence>
          </button>
        </div>
      )} */}
    </motion.div>
  );
}